export interface Autolecture {
  TipoFlusso: string;
  NomeFile: string;
  StatoElaborazione: string;
  EsitoCaricamento: string;
  DataInserimento: string;
  IdFile: string;
  SezioneCaricamento: string;
}
